export function isSidebarRouteActive(pathname, paths) {
  return (Array.isArray(paths) ? paths : [paths]).some((path) => {
    const cleanPath = path.split("?")[0];
    // Legacy grid details have their own root route, but belong to Mes grilles.
    const activePaths = cleanPath === "GridManagementView"
      ? [cleanPath, "GridDetailView"]
      : [cleanPath];
    return activePaths.some((activePath) =>
      pathname === `/${activePath}` || pathname.startsWith(`/${activePath}/`)
    );
  });
}
